import React from 'react';
import { HeartPulseIcon } from 'lucide-react';
export const TitleSlide = () => {
  return <div className="flex flex-col items-center justify-center p-8 md:p-16 min-h-[600px] bg-gradient-to-br from-white to-[#f7f3ef]" data-id="element-1438">
      <div className="flex items-center mb-6" data-id="element-1439">
        <HeartPulseIcon className="w-12 h-12 text-[#d4af37] mr-3" data-id="element-1440" />
        <h1 className="text-4xl md:text-6xl font-light text-[#333333]" data-id="element-1441">mosy</h1>
      </div>
      <h2 className="text-2xl md:text-4xl font-light text-center text-[#333333] mb-6" data-id="element-1442">
        Engagement & Retentiesysteem
      </h2>
      <p className="text-lg md:text-xl text-center text-[#666666] max-w-2xl mb-10" data-id="element-1443">
        Een verfijnde benadering voor mentale gezondheid
      </p>
      <div className="w-24 h-1 bg-[#d4af37] opacity-50 mb-8" data-id="element-1444"></div>
      <p className="text-sm md:text-base text-[#666666] text-center max-w-xl leading-relaxed" data-id="element-1445">
        Deze presentatie toont hoe Mosy subtiele gamification-elementen gebruikt
        om gebruikers te motiveren voor{' '}
        <span className="text-[#d4af37] font-medium" data-id="element-1446">
          regelmatige check-ins
        </span>
        , met betekenisvolle beloningen die echte waarde toevoegen aan hun
        mentale gezondheidsreis.
      </p>
    </div>;
};